import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LiveFeed from '../components/LiveFeed.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Live',
  setup(__props) {

const route = useRoute()
const isDark = computed(() => (route.query.theme as string) !== 'light')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LiveFeed, { "is-dark": _unref(isDark) }, null, 8, ["is-dark"]))
}
}

})